import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { couponActions } from "./actions";
import { CouponState } from "./types";

const initialState: CouponState = {
  coupons: null,
  couponExternalGroups: null,
  appliedCoupons: null,
  appCouponKey: null,
  appCoupons: [],
  unselectedAppCoupons: null,
  selectedAppCoupons: null,
  remainingSlot: 0,
};

export function CouponReducer(
  state = initialState,
  action: Action,
): CouponState {
  if (isType(action, couponActions.getCoupons.done)) {
    return {
      ...state,
      coupons: action.payload.result,
    };
  }
  if (isType(action, couponActions.getCouponExternals.done)) {
    return {
      ...state,
      couponExternalGroups: action.payload.result.couponGroups,
      remainingSlot: action.payload.result.remainingSlot,
    };
  }

  if (isType(action, couponActions.getAppliedCoupons.done)) {
    return {
      ...state,
      appliedCoupons: action.payload.result.appliedCoupons,
      unselectedAppCoupons: action.payload.result.unselectedAppCoupons,
      selectedAppCoupons: action.payload.result.selectedAppCoupons,
    };
  }

  if (isType(action, couponActions.removeAppliedCoupon.done)) {
    return {
      ...state,
      appliedCoupons: action.payload.result,
    };
  }

  // if (isType(action, couponActions.applyCoupon.done)) {
  //   return {
  //     ...state,
  //     appliedCoupons: action.payload.result,
  //     selectedAppCoupons: action.payload.params.isAppCoupon
  //       ? null
  //       : state.selectedAppCoupons,
  //   };
  // }

  if (isType(action, couponActions.checkAppliedCouponMenu.done)) {
    return {
      ...state,
      appliedCoupons: action.payload.result,
      selectedAppCoupons: action.payload.params.isAppCoupon
        ? null
        : state.selectedAppCoupons,
    };
  }

  if (isType(action, couponActions.getLimitedCoupons.done)) {
    return {
      ...state,
      appCouponKey: action.payload.params.coupon_code?.[0] ?? null,
      appCoupons: action.payload.result,
    };
  }

  if (isType(action, couponActions.redeemCoupon.done)) {
    return {
      ...state,
      unselectedAppCoupons: action.payload.result,
    };
  }

  if (isType(action, couponActions.saveSelectedAppCoupon.done)) {
    return {
      ...state,
      appCouponKey: null,
      appCoupons: [],
      unselectedAppCoupons: action.payload.result.unselectedAppCoupons,
      selectedAppCoupons: action.payload.result.selectedAppCoupons,
    };
  }

  if (isType(action, couponActions.removeSelectedAppCoupon.done)) {
    return {
      ...state,
      selectedAppCoupons: action.payload.result,
    };
  }

  if (isType(action, couponActions.removeAllAppCoupons.done)) {
    return {
      ...state,
      appliedCoupons:
        state.appliedCoupons?.filter((coupon) => !coupon.isAppCoupon) ?? [],
      unselectedAppCoupons: null,
      selectedAppCoupons: null,
    };
  }

  if (isType(action, couponActions.clearCoupons.done)) {
    return {
      ...state,
      appliedCoupons: [],
      appCoupons: [],
      unselectedAppCoupons: null,
      selectedAppCoupons: null,
    };
  }

  if (isType(action, couponActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
